module.exports = __webpack_public_path__ + "img/iconTrashRed36.3892d6ed.svg";